import { useEffect, useRef } from 'react';
import { Clapperboard } from 'lucide-react';
import ShakeDropdown from './ShakeDropdown';
import { useShake } from '../ShakeProvider';

export default function ShakeEntrypoint() {
  const { isDropdownOpen, setDropdownOpen } = useShake();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleDocMouseDown = (e: MouseEvent) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleDocMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleDocMouseDown);
    };
  }, [isDropdownOpen, setDropdownOpen]);

  return (
    <div className="relative inline-block" ref={wrapperRef}>
      <button
        type="button"
        className="rounded-lg p-1.5 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
        aria-haspopup="menu"
        aria-expanded={isDropdownOpen}
        title="Shake"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setDropdownOpen((open: boolean) => !open);
        }}
      >
        <Clapperboard className="h-4 w-4" />
      </button>
      <ShakeDropdown />
    </div>
  );
}
